import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  seenAnAnnouncementRequest: ['announcementId'],
  seenAnAnnouncementSuccess: ['status'],
  seenAnAnnouncementFailure: null,
});

export const SeenAnAnnouncementTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  announcementId: null,
  fetching: null,
  success: null,
  error: null,
  status: null,
});

/* ------------- Selectors ------------- */

export const SeenAnAnnouncementSelectors = {
  getData: (state: any) => state.data,
};

/* ------------- Reducers ------------- */

// request the data from an api
export const request = (state: any, { announcementId }: { announcementId: string }) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    announcementId,
    status: null,
  };
  
  // Handle both Immutable and plain JavaScript objects
  if (state && typeof state.merge === 'function') {
    return state.merge(updateData);
  } else {
    return { ...state, ...updateData };
  }
};

// successful api lookup
export const success = (state: any, action: { status: any }) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    status,
  };
  
  // Handle both Immutable and plain JavaScript objects
  if (state && typeof state.merge === 'function') {
    return state.merge(updateData);
  } else {
    return { ...state, ...updateData };
  }
};

// Something went wrong somewhere.
export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: null,
  };
  
  // Handle both Immutable and plain JavaScript objects
  if (state && typeof state.merge === 'function') {
    return state.merge(updateData);
  } else {
    return { ...state, ...updateData };
  }
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SEEN_AN_ANNOUNCEMENT_REQUEST]: request,
  [Types.SEEN_AN_ANNOUNCEMENT_SUCCESS]: success,
  [Types.SEEN_AN_ANNOUNCEMENT_FAILURE]: failure,
});
